import {
  heroArrowDown,
  heroArrowDownCircle,
  heroArrowLeft,
  heroArrowLongDown,
  heroArrowLongUp,
  heroArrowRight,
  heroArrowRightCircle,
  heroArrowUp,
  heroBanknotes,
  heroBars3,
  heroBell,
  heroBriefcase,
  heroBuildingOffice,
  heroCalendar,
  heroCalendarDays,
  heroChartPie,
  heroChatBubbleBottomCenter,
  heroChatBubbleBottomCenterText,
  heroChatBubbleOvalLeft,
  heroChatBubbleOvalLeftEllipsis,
  heroCheck,
  heroCheckCircle,
  heroChevronDown,
  heroChevronLeft,
  heroChevronRight,
  heroChevronUp,
  heroClock,
  heroComputerDesktop,
  heroCog8Tooth,
  heroDocumentArrowDown,
  heroExclamationCircle,
  heroExclamationTriangle,
  heroFolder,
  heroFolderOpen,
  heroFolderPlus,
  heroFunnel,
  heroLightBulb,
  heroLockClosed,
  heroMagnifyingGlass,
  heroMoon,
  heroPaperAirplane,
  heroPause,
  heroPauseCircle,
  heroPencil,
  heroPlay,
  heroPlayCircle,
  heroPlayPause,
  heroPlus,
  heroQuestionMarkCircle,
  heroServer,
  heroSparkles,
  heroStar,
  heroSun,
  heroTrash,
  heroUserGroup,
  heroUsers,
  heroXCircle,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import {
  heroCalendarMini,
  heroCheckCircleMini,
  heroClockMini,
  heroCurrencyDollarMini,
  heroExclamationCircleMini,
  heroUserMini,
} from '@ng-icons/heroicons/mini';
import {
  heroBuildingOfficeSolid,
  heroChartPieSolid,
  heroCheckCircleSolid,
  heroCheckSolid,
  heroClockSolid,
  heroEllipsisVerticalSolid,
  heroExclamationCircleSolid,
  heroExclamationTriangleSolid,
  heroFunnelSolid,
  heroInformationCircleSolid,
  heroStarSolid,
  heroUserSolid,
  heroXCircleSolid,
  heroXMarkSolid,
} from '@ng-icons/heroicons/solid';

export const icons = {
  heroExclamationCircleMini,
  heroServer,
  heroPlayPause,
  heroPause,
  heroPlay,
  heroUsers,
  heroArrowLeft,
  heroArrowRight,
  heroArrowRightCircle,
  heroXCircle,
  heroChevronUp,
  heroChevronDown,
  heroPencil,
  heroChevronLeft,
  heroChevronRight,
  heroClockMini,
  heroCog8Tooth,
  heroCurrencyDollarMini,
  heroXMark,
  heroBars3,
  heroDocumentArrowDown,
  heroFunnelSolid,
  heroMagnifyingGlass,
  heroPlus,
  heroUserMini,
  heroCheckCircle,
  heroCalendarMini,
  heroBuildingOffice,
  heroUserGroup,
  heroBriefcase,
  heroBanknotes,
  heroCalendar,
  heroCalendarDays,
  heroChatBubbleBottomCenter,
  heroChatBubbleBottomCenterText,
  heroChatBubbleOvalLeft,
  heroChatBubbleOvalLeftEllipsis,
  heroCheckCircleSolid,
  heroCheckCircleMini,
  heroSparkles,
  heroArrowUp,
  heroArrowLongUp,
  heroArrowDown,
  heroArrowDownCircle,
  heroArrowLongDown,
  heroInformationCircleSolid,
  heroCheck,
  heroTrash,
  heroFolder,
  heroFolderOpen,
  heroBell,
  heroEllipsisVerticalSolid,
  heroExclamationCircleSolid,
  heroExclamationCircle,
  heroStar,
  heroStarSolid,
  heroQuestionMarkCircle,
  heroXCircleSolid,
  heroExclamationTriangleSolid,
  heroExclamationTriangle,
  heroFolderPlus,
  heroLightBulb,
  heroXMarkSolid,
  heroCheckSolid,
  heroUserSolid,
  heroBuildingOfficeSolid,
  heroLockClosed,
  heroPaperAirplane,
  heroClock,
  heroChartPie,
  heroPlayCircle,
  heroPauseCircle,
  heroFunnel,
  heroChartPieSolid,
  heroClockSolid,
  heroComputerDesktop,
  heroMoon,
  heroSun,
};
